import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { forgotPassword, setEmail } from '../../features/auth/auth.slice';
import logo from '../../assets/logo.png';
import Spinner from '../utilities/Spinner';
import { useEffect } from 'react';

const ForgotPassword = ({ setAuthType }) => {
  const [data, setData] = useState({
    email: '',
  });
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const submitData = () => {
    if (data.email.length > 0) {
      dispatch(setEmail(data.email));
      dispatch(forgotPassword(data));

      setAuthType(`checkmail`);
    }
  };

  return (
    <>
      <>
        <img src={logo} alt="Postager Logo" />
        <p className="font-semibold">Forgot Your Password?</p>
      </>
      <form
        className="space-y-5 px-7 w-full pt-5"
        onSubmit={(e) => {
          e.preventDefault();
          submitData();
        }}
      >
        <p className="text-sm text-center">
          No Worries, We Will Send You The Reset Instructions
        </p>
        <input
          type="text"
          class="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
          placeholder="Enter your Email associated with account"
          onChange={(e) => {
            setData({
              email: e.target.value,
            });
          }}
          required
        />

        <div className="flex flex-col justify-center items-center w-full space-y-3">
          <button
            className={`text-white   focus:ring-4 ${
              loading ? 'bg-blue-300' : 'bg-darkblue hover:bg-blue-800'
            } focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center self-center mt-5 flex justify-center`}
            type="submit"
            disabled={loading}
          >
            {loading ? <Spinner sm={true} /> : 'Reset Password'}
          </button>

          <a
            href="#"
            className="text-sm hover:underline"
            onClick={() => setAuthType('login')}
          >
            Back To Login Page
          </a>
        </div>
      </form>
    </>
  );
};

export default ForgotPassword;
